import { createSlice } from '@reduxjs/toolkit';
import { initialState, commonReducers } from './fileVersionHistory.slice';

const mvdfVersionHistorySlice = createSlice({
  name: 'mvdfVersionHistory',
  initialState,
  reducers: { ...commonReducers },
});

export default mvdfVersionHistorySlice.reducer;
export const {
  setOpenFileVersionHistory,
  setOpenDeleteVersionConfirmationModal,
  addToFileVersions,
  getNextVersions,
  deletedLastVersion,
} = mvdfVersionHistorySlice.actions;
